import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    warning: true,
    page: null,
    string: '',
    status: 'idle',
    error: null,
};

const warningModalSlice = createSlice({
    name: 'warning',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setWarning: (state, action) => {
            return {
              ...state,
              warning: action.payload,
            }
        },
        setString: (state, action) => {
            return {
              ...state,
              string: action.payload,
            }
        }
    },
});

export const { reset, setWarning, setString } = warningModalSlice.actions;
export const selectWarningModal = state => state.warning.warning;
export const selectPage = state => state.warning.string;

export default warningModalSlice.reducer;
